export enum LabelType {
  AREA_TYPE = 'areaType',
  SUB_AREA = 'subArea',
  MEASUREMENT = 'measurement',
  PRESET_TEXT = 'presetText',
  CUSTOM_TEXT = 'customText',
}
